// extracted by mini-css-extract-plugin
export var option = "_42-1";
export var optionActive = "_42-2";
export var pill = "_42-0";